import {TrainingSpecialitiesDao} from '../../dao';
import {TrainingSpecialtiesModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateTrainingSpeciality(
    userData: Record<string, string>,
    trainingSpecialtyId: number,
    update: Record<string, any>
) {
    try {
        const result = await TrainingSpecialitiesDao.updateTrainingSpecialty(userData.userToken, trainingSpecialtyId, update);

        const resultParsed = TrainingSpecialtiesModel.parseTrainingSpecialties(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
